// types
import { i18nModules, isResultSuccess } from '../types';
/**
 * I18n service
 */
class I18nService {
    i18nAdapter;
    /**
     * I18nService constructor
     */
    constructor({ i18nAdapter }) {
        this.i18nAdapter = i18nAdapter;
        this.mergeMessages();
    }
    /**
     * Return the coresponding translation for a given key
     * can accept props as options
     *
     * @param key - the path of the translation
     * @param options - props to map in the translation
     * @returns the translation filled with is options
     */
    translate(key, options) {
        return this.i18nAdapter.translate(key, options);
    }
    /**
     * Fetch all needed i18n and merge them
     */
    async mergeMessages() {
        const promises = Object.keys(i18nModules).map(async (module) => {
            const result = await this.i18nAdapter.getI18nFromRessourceModule(i18nModules[module]);
            if (isResultSuccess(result))
                this.i18nAdapter.mergeTranslations(result.response);
        });
        promises.push(this.#getI18nFromTenant());
        await Promise.all(promises);
    }
    async #getI18nFromTenant() {
        const result = await this.i18nAdapter.getI18nFromTenant();
        if (isResultSuccess(result))
            this.i18nAdapter.mergeTranslations(result.response);
    }
    getMergedI18n() {
        return this.i18nAdapter.getTranslationJson();
    }
    /**
     * Retrieve teleservice i18n merged with base portal translations
     *
     * @param typeTeleservice - Type of teleservice to retrieve translations
     * @param teleserviceReference - Reference of teleservice for which we retrieve translations
     */
    async getMergedTeleserviceI18n(typeTeleservice, teleserviceReference) {
        const result = await this.i18nAdapter.getTeleserviceTranslationJson(typeTeleservice, teleserviceReference);
        if (isResultSuccess(result))
            return result.response;
        throw result.error;
    }
}
export { I18nService };
//# sourceMappingURL=i18n-service.js.map